import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import {
	ActionsTopMembers,
	failureTopMembers,
	loadTopMembersSuccess,
	loadGetTopMembers,
} from "./actions";
import Env from "../../../consts/env";

function* loadTopMembers(params) {

	try {

		yield put(loadGetTopMembers());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getTopMembers`;
		const headers = {
			...Env.HEADERS,
			Authorization: params.Authorization,
		};
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(Env.REQUEST_TIMEOUT),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureTopMembers(yield "Error Timeout..."));

		} else {

			const dataTopMembers = yield response.json();

			if (response.status !== 200) {

				yield put(failureTopMembers(yield response.statusText));

			} else {

				yield put(loadTopMembersSuccess(yield dataTopMembers));

			}

		}

	} catch (err) {

		yield put(failureTopMembers(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsTopMembers.GET_TOP_MEMBERS, loadTopMembers);

}
